window.addEventListener('load', () => {
    toggleSearch();
});

const toggleSearch = () => {
    const searchButton = document.querySelector('.navigation__search-toggle');
    const backButton = document.querySelector('.twz-element-search__back');

    searchButton.addEventListener('click', (e) => {
        document.body.classList.add('search-active');
        document.querySelector('.twz-element-search__input').focus();
    });

    backButton.addEventListener('click', (e) => {
        document.body.classList.remove('search-active');
    })

    window.addEventListener('mouseup', (e) => {
        if (e.target.closest('.navigation') === null && document.body.classList.contains('search-active')) {
            document.body.classList.remove('search-active');
        }
    })
}